import React, { useEffect, useState } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { login } from '../../api/authApi';
import { useNavigate } from "react-router-dom";
import { setAccessToken, setRefreshToken } from '../../util/auth';
import withShowAlert from '../../components/withShowAlert';

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>

      <Link color="inherit" href="https://www.linx.com.br/">
        Linx
      </Link>{' '}
      {new Date().getFullYear()}
      {' © Todos os direitos reservados'}
    </Typography>
  );
}

function Login({showAlert}) {
  const [remember, setRemember] = useState(localStorage.remember || false)
  let history = useNavigate();

  const loggedIn = localStorage.accessToken

  useEffect(() => {
    if (loggedIn) {
      return history("/io_credentials");
    }
  }, [loggedIn, history]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
  
    try {
      const response = await login(data.get('email'), data.get('password'));
      setAccessToken(response.data.access_token, remember);
      setRefreshToken(response.data.refresh_token, remember);
      localStorage.setItem('remember', remember);
      history('/io_credentials');
    } catch (error) {
      showAlert("Credenciais inválidas, tente novamente.", "error");
    }
  };
  

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Entrar
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="E-mail"
            name="email"
            autoComplete="email"
            autoFocus
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Senha"
            type="password"
            id="password"
            autoComplete="current-password"
          />
          <FormControlLabel
            control={<Checkbox value="remember"
              checked={remember}
              onChange={(event) => setRemember(event.target.checked)}
              color="primary" />}
            label="Manter conectado"
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Entrar
          </Button>
        </Box>
      </Box>
      <Copyright sx={{ mt: 8, mb: 4 }} />
    </Container>
  );
}

export default withShowAlert(Login)